import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TableLampIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 20.98 21.016",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.016),
    children: [/*#__PURE__*/jsx("path", {
      d: "m17.974 8.196-8.18-4.189"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.412 16.348 3.173-6.346"
    }), /*#__PURE__*/jsx("path", {
      d: "m17.822 8.814a1.329 1.329 0 1 0 1.329-1.329 1.329 1.329 0 0 0 -1.329 1.329z"
    }), /*#__PURE__*/jsx("path", {
      d: "m8.85 9.897a1.156 1.156 0 0 0 .327-.981l-.532-3.722.92-.92a2.167 2.167 0 1 0 -3.065-3.061l-.92.917-3.722-.531a1.152 1.152 0 0 0 -.977 1.962l6.338 6.336a1.152 1.152 0 0 0 1.635 0z"
    }), /*#__PURE__*/jsx("path", {
      d: "m18.175 20.516a.867.867 0 0 0 .824-1.134 5.539 5.539 0 0 0 -10.042 0 .867.867 0 0 0 .824 1.134z"
    })]
  });
};

export { PM2TableLampIcon };
//# sourceMappingURL=table-lamp.js.map
